import banner from './img/research-banner.jpg'

function getYearsExperience(){
    let startYear = 2010
    let currentYear = new Date().getFullYear()
    return(currentYear - startYear)
}
function About() {
    return (
        <div className="container-single">
            <img src={banner} className="fullColImg" /><p></p>
            <p>
                I am interested in human centered AI, natural language, and telepresence. Issues of representation in the mind, and its computational implementation. I conducted original research in these domains at both McGill and UBC.
            </p>
            <p>
                Fun fact: I also have {getYearsExperience()} years experience in film, with clients including: The Globe and Mail, BC Bioenergy Network, Dentons, and many more. Why am I doing HCI now? I like interaction, and also think it's really not that different. Design is still design.
            </p>

            <p>
                <div id="quickFacts">
                    <div className="factList">
                        <i>Top Languages</i>
                        <br/>
                        <ul>
                            <li>JavaScript</li>
                            <li>Python</li>
                            <li>C#</li>
                            <li>R</li>
                            <li>Java</li>
                        </ul>
                    </div>

                    {/* <div className="factList">
                        <i>libraries</i>
                        <ul>
                            <li>React (I wrote this site in it!)</li>
                            <li>Node.js</li>
                            <li>PyTorch</li>
                            <li>Tensorflow</li>
                        </ul>
                    </div> */}

                    <div className="factList">
                        <i>Programs</i>
                        <ul>
                            <li>Adobe Creative Suite</li>
                            <ul>
                                <li>After Effects</li>
                                <li>Premiere</li>
                                <li>Illustrator</li>
                                <li>Photoshop</li>
                                <li>XD</li>
                                <li>InDesign</li>
                            </ul>
                            <li>Unity3D</li>
	    		    <li>Godot</li>
                            <li>Axure</li>
                            <li>Figma</li>
                        </ul>
                    </div>

                    <div className="factList">
                        <i>Research Techniques</i>
                        <ul>
                            <li>Cognitive walkthrough</li>
                            <li>Heuristic evaluation</li>
                            <li>Personas</li>
                            <li>Storyboarding</li>
                            <li>Paper Prototyping</li>
                            <li>Focus groups and interviews</li>
                            <li>Co-design</li>
                            <li>Quantiative experimental design</li>

                        </ul>
                    </div>
                </div>
            </p>

            {/* <p>
                <span className="subheader">Overarching research themes</span>
            </p>
            <p>
                🧍 <b>Telepresence</b>
                <ul>
                    <li>How can we establish a shared sense of being in the world?</li>
                    <li>How can we reduce the attentional demands of modern telepresence systems?</li>
                </ul>

                💬 <b>Language</b>
                <ul>
                    <li>How can we design for human language <b>as it naturally occurs</b>?</li>
                    <li>How do we integrate multimodal interfaces?</li>
                    <li>How is linguistic representation shared and communicated?</li>
                </ul>

                💞 <b>Affective Computing</b>
                <ul>
                    <li>How should we represent, model, and process emotion?</li>
                </ul>
            </p> */}
            {/* The pandemic has made us more reliant on videoconferencing systems than ever before. Yet many videoconferencing systems offer a degraded conversational experience. This can be due to technical limitations, but it is also a design problem: many videoconferencing systems assume a theory of human conversation that may not hold in practice. For example, many systems in their default mode are optimized for serial communication, when in reality there are parallel channels of communication. My current work is focused on how to design for natural human conversation in remote settings. */}


        </div>
    )
}

export { About }
